<!--
Copyright 2024 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the
project root for license information.
-->
<div mat-dialog-container>
  <div mat-dialog-title>
    @if (!data.isNewInject) {
      <span>Edit</span>
    }
    @if (data.isNewInject) {
      <span>Create</span>
    }
    an Inject
    &nbsp;
    <button
      mat-icon-button
      (click)="handleEditComplete(false)"
      title="Cancel"
      class="close-button"
      tabindex="-1"
      >
      <mat-icon class="mdi-24px self-center" fontIcon="mdi-close-circle-outline"></mat-icon>
    </button>
  </div>
  @if (!!data && data.inject !== undefined && data.inject !== null) {
    <div mat-dialog-content>
      <!-- name -->
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Name</mat-label>
            <input
              type="text"
              title="The Name of the Inject"
              matInput
              placeholder="Name (required)"
              [(ngModel)]="data.inject.name">
          </mat-form-field>
        </div>
      </div>
      <!-- description -->
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Description</mat-label>
            <input
              type="text"
              title="The Description of the Inject"
              matInput
              placeholder="Description (required)"
              [(ngModel)]="data.inject.description">
          </mat-form-field>
        </div>
      </div>
      <!-- requires inject -->
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Prerequisite Inject</mat-label>
            <mat-select placeholder="Prerequisite Inject" [(ngModel)]="data.inject.requiresInjectId">
              <mat-option [value]="null" title="None"></mat-option>
              @for (inject of otherInjects(data.inject.id); track inject) {
                <mat-option [value]="data.inject.id" title="{{ data.inject.name}}">
                  {{ inject.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      @for (dataField of data.dataFieldList; track dataField) {
        <div class="add-margin">
          <div class="full-width">
            <app-data-value
              [(value)]="getDataValue(dataField.id).value"
              [dataField]="dataField"
              [canEdit]="data.isEditMode"
              [canApprove]="false"
              [isOwner]="false"
              [showValueOnly]="!data.isEditMode"
              [organizationOptions]="[]"
              [teamOptions]="[]"
              [unitOptions]="data.unitList"
              [cardOptions]="[]"
              [moveOptions]="[]"
              [gallerySourceTypeOptions]="[]"
              [userOptions]="data.userList"
            ></app-data-value>
            <br />
          </div>
        </div>
      }
    </div>
  }
  <div class="cssLayoutRowStartCenter bottom-button">
    <div class="delete-button">
      <button mat-stroked-button (click)="handleEditComplete(true)" [disabled]="!errorFree()" style="margin-left: 40px;">Save</button>
    </div>
    <div class="delete-button">
      <button mat-stroked-button (click)="handleEditComplete(false)">Cancel</button>
    </div>
  </div>
</div>
